import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./reducers/index";
import axiosReduxMiddleware from "./axiosReduxMiddleware";
import thunk from "redux-thunk";
import socketMiddleware from "./middlewares/socketMiddleware.js";
import socketIOClient from "socket.io-client";
import { SOCKETURL } from "../contants";

let socket = socketIOClient(SOCKETURL, { secure: true });
export default function initializeStore(initialState = {}) {
  const composeEnhancers =
    (typeof window !== "undefined" &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;

  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(
      applyMiddleware(axiosReduxMiddleware, socketMiddleware(socket), thunk),
    ),
  );
  store.subscribe(() => {});

  return store;
}
